export default "__VITE_ASSET__DcJ_ehRU__"